import { useAxiosClient } from '../';

export const useTokenApi = () => {
    const {axiosClientNoIntercept} = useAxiosClient();

    return {
        login: async (email, password) => await axiosClientNoIntercept.post('v1/token/login', {email, password}).then(res => res).catch(err => err),
        refresh: async (token, refreshToken) => await axiosClientNoIntercept.post('v1/token/refresh-token', {token, refreshToken}).then(res => res).catch(err => err),
        loginPlaymove: async (email, password, rememberMe) => await axiosClientNoIntercept.post('v1/token/login-playmove', {email, password, rememberMe}).then(res => res).catch(err => err),
    }
}